import { fmtMT } from "@/lib/mountainTime";

const money = (a, c) => (a == null ? "—" : `$${Number(a).toLocaleString("en-CA", { maximumFractionDigits: 2 })} ${c || ""}`.trim());
const GSM = /^[A-Za-z0-9 \n\r@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ!"#¤%&'()*+,\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\[~\]|€]*$/;

// Estimated SMS segments: GSM-7 = 160 chars (153 per part when split); anything else (emoji, em dash…) = UCS-2, 70 (67).
export function smsSegments(text) {
  const t = text || "";
  if (GSM.test(t)) {
    const n = [...t].reduce((k, ch) => k + ("^{}\\[~]|€".includes(ch) ? 2 : 1), 0);
    return { chars: n, segments: n <= 160 ? 1 : Math.ceil(n / 153), encoding: "GSM-7" };
  }
  const n = [...t].length;
  return { chars: n, segments: n <= 70 ? 1 : Math.ceil(n / 67), encoding: "Unicode" };
}

function Delivery({ d, label, preview }) {
  const simulated = d.status === "blocked_preview";
  const seg = smsSegments(d.body);
  return (
    <div data-testid={`sms-log-delivery-${d.id}`} className="rounded-md border bg-stone-50 p-2 space-y-1">
      <div className="flex flex-wrap justify-between gap-2 text-xs">
        <span data-testid={`sms-log-recipient-${d.id}`}>To: <b>{d.recipient_name}</b> …{String(d.to || "").slice(-4)}</span>
        <span data-testid={`sms-log-status-${d.id}`} className={`rounded-full px-2 py-0.5 font-semibold ${simulated ? "bg-sky-100 text-sky-900" : d.status === "sent" ? "bg-emerald-100 text-emerald-800" : "bg-stone-200 text-stone-700"}`}>
          {simulated ? "Simulated — Not Sent" : label}{d.test_session_id ? " · controlled test" : ""}{d.provider_status ? ` · Twilio: ${d.provider_status}` : ""}{d.error ? ` (${d.error})` : ""}
        </span>
      </div>
      <pre data-testid={`sms-log-body-${d.id}`} className="whitespace-pre-wrap break-words text-xs font-mono text-stone-800">{d.body}</pre>
      {preview && (
        <p data-testid={`sms-log-length-${d.id}`} className={`text-[11px] ${seg.segments > 1 ? "text-amber-800 font-semibold" : "text-stone-500"}`}>
          {seg.chars} characters · {seg.segments} SMS segment{seg.segments > 1 ? "s" : ""} ({seg.encoding}, estimate)
        </p>
      )}
    </div>
  );
}

export function SmsLogItem({ n, eventLabel, statusLabels, onRead, preview }) {
  return (
    <div data-testid={`notify-item-${n.id}`} className={`rounded-xl border p-3 text-sm space-y-2 ${n.read ? "bg-white" : "bg-[#FFFBEB]"}`}>
      <div className="flex flex-wrap justify-between gap-2">
        <b data-testid={`notify-event-label-${n.id}`}>{eventLabel}</b>
        <span className="text-xs text-stone-500" data-testid={`notify-time-${n.id}`}>{fmtMT(n.created_at)}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-3 gap-y-0.5 text-xs text-stone-700">
        <span data-testid={`notify-horse-${n.id}`}>Horse: <b>{n.horse_name}</b></span>
        <span data-testid={`notify-amount-${n.id}`}>Bid amount: <b>{money(n.amount, n.currency)}</b></span>
        {n.link && <a data-testid={`notify-link-${n.id}`} href={n.link} className="text-amber-800 font-semibold underline">Open auction in Bid Management</a>}
      </div>
      <p>{n.message}</p>
      {n.reason && <p data-testid={`notify-reason-${n.id}`} className="text-xs text-stone-600">Reason: {n.reason}</p>}
      {n.deliveries.map((d) => <Delivery key={d.id} d={d} label={statusLabels[d.status] || d.status} preview={preview} />)}
      {!n.deliveries.length && <p className="text-xs text-stone-500">No text — no active recipient for this alert type.</p>}
      {!n.read && <button data-testid={`notify-read-${n.id}`} onClick={onRead} className="text-xs text-amber-800 font-semibold">Mark as read</button>}
    </div>
  );
}
